import { createContext, useCallback, useContext, useMemo, useState } from "react";

const EMPTY_SIGNUP_STATE = {
  email: "",
  password: "",
  selectedPlan: null,
  billingInterval: "monthly",
  accountName: "",
  accountId: null,
};

const noop = () => {};

const defaultValue = {
  ...EMPTY_SIGNUP_STATE,
  setEmail: noop,
  setPassword: noop,
  setSelectedPlan: noop,
  setBillingInterval: noop,
  setAccountName: noop,
  setAccountId: noop,
  reset: noop,
};

export const SignupContext = createContext(defaultValue);

export const useSignup = () => useContext(SignupContext);

export function SignupProvider({ children }) {
  const [email, setEmail] = useState(EMPTY_SIGNUP_STATE.email);
  const [password, setPassword] = useState(EMPTY_SIGNUP_STATE.password);
  const [selectedPlan, setSelectedPlan] = useState(EMPTY_SIGNUP_STATE.selectedPlan);
  const [billingInterval, setBillingInterval] = useState(
    EMPTY_SIGNUP_STATE.billingInterval,
  );
  const [accountName, setAccountName] = useState(EMPTY_SIGNUP_STATE.accountName);
  const [accountId, setAccountId] = useState(EMPTY_SIGNUP_STATE.accountId);

  const reset = useCallback(() => {
    setEmail(EMPTY_SIGNUP_STATE.email);
    setPassword(EMPTY_SIGNUP_STATE.password);
    setSelectedPlan(EMPTY_SIGNUP_STATE.selectedPlan);
    setBillingInterval(EMPTY_SIGNUP_STATE.billingInterval);
    setAccountName(EMPTY_SIGNUP_STATE.accountName);
    setAccountId(EMPTY_SIGNUP_STATE.accountId);
  }, []);

  const value = useMemo(
    () => ({
      email,
      password,
      selectedPlan,
      billingInterval,
      accountName,
      accountId,
      setEmail,
      setPassword,
      setSelectedPlan,
      setBillingInterval,
      setAccountName,
      setAccountId,
      reset,
    }),
    [email, password, selectedPlan, billingInterval, accountName, accountId, reset],
  );

  return <SignupContext.Provider value={value}>{children}</SignupContext.Provider>;
}
